import React from "react";

export default function Card({ children, className = "" }) {
  return (
    <div
      className={`max-w-full bg-surface-card  sm:p-[clamp(22px,5vw,40px)]  text-text-dark font- ${className}`}
    >
      {children}
    </div>
  );
}

{
  /* <div
      className={`w-[620px] max-w-full bg-surface-card border border-[#E3DCD1] rounded-3xl p-[clamp(22px,5vw,40px)] shadow-[0_24px_60px_-32px_rgba(34,32,28,0.35)] text-text-dark font-['Nunito_Sans',system-ui,sans-serif] ${className}`}
    ></div> */
}
